import { useQuery } from '@tanstack/vue-query'
import { computed, ref, type MaybeRef, toValue } from 'vue'
import fetchApi, { FetchApiError } from '@/utils/fetchApi'
import type { ColdMonitoringCallDetailsResponse } from 'shared'

export const coldCallDetailsQueryKey = (callId: string | null | undefined) =>
  ['cold-monitoring', 'call-details', callId] as const

export function useColdCallDetailsQuery(
  callId: MaybeRef<string | null | undefined>,
  callDate: MaybeRef<string | null | undefined> = ref(null),
) {
  return useQuery({
    queryKey: computed(() => coldCallDetailsQueryKey(toValue(callId))),
    queryFn: async (): Promise<ColdMonitoringCallDetailsResponse> => {
      const id = toValue(callId)
      const date = toValue(callDate)
      const endpoint = date
        ? `/api/cold-monitoring/${String(id)}/details?date=${date}`
        : `/api/cold-monitoring/${String(id)}/details`
      return await fetchApi<ColdMonitoringCallDetailsResponse>(
        { endpoint, method: 'GET' },
        { suppressAlert: true },
      )
    },
    enabled: computed(() => Boolean(toValue(callId))),
    retry: (_, error) =>
      !(error instanceof FetchApiError && [403, 404, 422].includes(error.status)),
    staleTime: 5 * 60 * 1000,
  })
}
